export const isBase64 = (url: string) => {
  const regex = /^data:image\/(png|jpeg|jpg|gif|svg\+xml);base64,/;
  return regex.test(url);
};
